import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Image = ({ image, alt, imgStyle, ...other }) => {
  if (image.node?.gatsbyImageData) {
    return <GatsbyImage image={getImage(image.node)} alt={alt} imgStyle={imgStyle} {...other} />;
  }
  return <img src={image.node.publicURL} alt={alt} {...other} />;
};

export default Image;
